<template>
  <el-card>
    <el-form label-width="auto"  ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('编号')" v-if="isEdit">
        <el-input :placeholder="$t('编号')" disabled :value="data.num" />
      </el-form-item>

      <el-form-item :label="$t('公告标题')" prop="title">
        <el-input :placeholder="$t('公告标题')" v-model="formData.title" />
      </el-form-item>

      <el-form-item :label="$t('公告内容')" prop="content">
        <wangeditor ref="editor" :upload-img-server="$api.file.uploadEditor" v-model="formData.content" />
      </el-form-item>

      <el-form-item :label="$t('公告状态')">
        <el-select v-model="formData.status" :placeholder="$t('公告状态')">
          <el-option v-for="(item, index) in NOTICE_STATUS" :key="index" :value="item.value" :label="$t(item.label)" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('发布时间')">
        <div class="flex" style="column-gap: 10px">
          <el-input disabled :value="releaseTime" />
          <el-button size="small" icon="el-icon-time" @click="showDialog = true">{{$t('定时发布')}}</el-button>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleConfirm">{{$t('确认')}}</el-button>
        <el-button @click="resetForm">{{$t('重置')}}</el-button>
      </el-form-item>
    </el-form>

    <el-dialog :title="$t('定时发布')" :visible.sync="showDialog" @close="handleCloseDialog">
      <el-form size="small" ref="timeForm" :model="timeForm">
        <el-form-item :label="$t('定时发布')" prop="time" :rules="{required: true, message: $t('请选择发布时间'), trigger: 'change'}">
          <el-date-picker
              v-model="timeForm.time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :placeholder="$t('选择日期时间')">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="handleSelectTime">{{$t('确认')}}</el-button>
        <el-button size="small" @click="showDialog = false">{{$t('取消')}}</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import Wangeditor from "@/components/Wangeditor";
import {NOTICE_STATUS} from "@/constant/constant";
import {resetEmpty} from "@/utils/common";
let timer = null;

export default {
  name: "NoticeForm",
  components: {Wangeditor},
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        title: "",
        content: "",
        status: "open",
      },
      releaseTime: null,
      NOTICE_STATUS,
      rules: {
        title: {required: true, message: this.$t('请输入公告标题'), trigger: 'blur'},
        content: {required: true, message: this.$t('请输入公告内容'), trigger: 'blur'},
      },
      showDialog: false,
      // 定时时间
      timeForm: {
        time: ""
      },
    }
  },
  methods: {
    // 确认
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        const data = {...this.formData};
        data.releaseTime = this.releaseTime;
        this.$emit("save", {...data});
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.formData.status = "open";
      this.$refs.editor.clear();
    },

    handleCloseDialog() {
      this.$refs.timeForm.resetFields();
      resetEmpty(this.timeForm);
    },

    // 选择定时时间
    handleSelectTime() {
      this.$refs.timeForm.validate(valid => {
        if(!valid) return;
        this.showDialog = false;
        this.releaseTime = this.$moment(this.timeForm.time).format("YYYY-MM-DD HH:mm:ss");
        clearInterval(timer);
      })
    },

    handleIntervalTime() {
      timer = setInterval(() => {
        this.releaseTime = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000)
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
        const {releaseTime} = val;
        if(releaseTime) {
          this.releaseTime = this.$moment(releaseTime).format("YYYY-MM-DD HH:mm:ss");
        }
      },
      immutable: false,
    }
  },
  created() {
    if(!this.isEdit) {
      this.handleIntervalTime();
      // 组件销毁关闭定时器
      this.$once('hook:beforeDestroy', () => {
        clearInterval(timer);
      })
    }
  },
}
</script>

<style scoped>

.el-form {
  max-width: 700px;
}

/deep/ .el-dialog {
  width: 400px;
  border-radius: 10px;
}

</style>
